import React, { useState } from 'react';
import { Card } from '../Shared/Card';
import { CalendarIcon, ClockIcon, CheckCircleIcon, AlertCircleIcon, FileTextIcon, DownloadIcon } from 'lucide-react';
export function Surveillance() {
  const [activeMonth, setActiveMonth] = useState('May');
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const surveillanceItems = [{
    id: 'SV001',
    title: 'Monthly Performance Report',
    pool: 'Q3 RTL Pool',
    dueDate: 'May 15, 2023',
    status: 'Not Started',
    type: 'DBRS'
  }, {
    id: 'SV002',
    title: 'Quarterly Collateral Review',
    pool: 'Bridge Loan Package',
    dueDate: 'May 30, 2023',
    status: 'In Progress',
    type: 'Acra'
  }, {
    id: 'SV003',
    title: 'Monthly Servicing Report',
    pool: 'Q3 RTL Pool',
    dueDate: 'May 10, 2023',
    status: 'Ready',
    type: 'DBRS'
  }, {
    id: 'SV004',
    title: 'Delinquency Report',
    pool: 'Bridge Loan Package',
    dueDate: 'May 5, 2023',
    status: 'Submitted',
    type: 'Lima One'
  }, {
    id: 'SV005',
    title: 'Collateral Performance Update',
    pool: 'Q3 RTL Pool',
    dueDate: 'Jun 15, 2023',
    status: 'Not Started',
    type: 'DBRS'
  }];
  const filteredItems = surveillanceItems.filter(item => {
    const itemMonth = new Date(item.dueDate).toLocaleString('default', {
      month: 'short'
    });
    return itemMonth === activeMonth;
  });
  const getStatusBadgeClass = (status: string) => {
    switch (status) {
      case 'Not Started':
        return 'bg-muted text-foreground/70';
      case 'In Progress':
        return 'bg-warning/10 text-warning';
      case 'Ready':
        return 'bg-success/10 text-success';
      case 'Submitted':
        return 'bg-primary/10 text-primary';
      default:
        return 'bg-muted text-foreground/70';
    }
  };
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'Not Started':
        return <ClockIcon className="w-5 h-5 text-muted-foreground" data-id="element-1425" />;
      case 'In Progress':
        return <AlertCircleIcon className="w-5 h-5 text-warning" data-id="element-1426" />;
      case 'Ready':
        return <CheckCircleIcon className="w-5 h-5 text-success" data-id="element-1427" />;
      case 'Submitted':
        return <FileTextIcon className="w-5 h-5 text-primary" data-id="element-1428" />;
      default:
        return <ClockIcon className="w-5 h-5 text-muted-foreground" data-id="element-1429" />;
    }
  };
  return <div className="space-y-6" data-id="element-1430">
      <div className="flex justify-between items-center" data-id="element-1431">
        <h2 className="text-xl font-semibold text-card-foreground" data-id="element-1432">
          Surveillance Scheduler & Tracker
        </h2>
        <div className="flex space-x-3" data-id="element-1433">
          <button className="px-4 py-2 bg-background border border-border rounded-full text-foreground/70 hover:bg-muted flex items-center text-sm transition-colors" data-id="element-1434">
            <DownloadIcon className="w-4 h-4 mr-2" data-id="element-1435" />
            Export Monthly Package
          </button>
          <button className="px-4 py-2 bg-success rounded-full text-foreground/70 hover:bg-success/80 flex items-center text-sm transition-colors" data-id="element-1436">
            <FileTextIcon className="w-4 h-4 mr-2" data-id="element-1437" />
            Prepare Submission
          </button>
        </div>
      </div>
      <div className="grid grid-cols-4 gap-6" data-id="element-1438">
        <Card className="col-span-1" data-id="element-1439">
          <h3 className="text-lg font-medium text-card-foreground mb-4" data-id="element-1440">
            Calendar
          </h3>
          <div className="space-y-4" data-id="element-1441">
            <div className="flex flex-wrap gap-2" data-id="element-1442">
              {months.map(month => <button key={month} onClick={() => setActiveMonth(month)} className={`px-3 py-1.5 text-sm rounded-md ${activeMonth === month ? 'bg-primary/10 text-primary' : 'bg-muted text-foreground/70 hover:bg-muted/80'}`} data-id="element-1443">
                  {month}
                </button>)}
            </div>
            <div className="pt-4 border-t border-border" data-id="element-1444">
              <h4 className="text-sm font-medium text-foreground/70 mb-3" data-id="element-1445">
                Status Summary
              </h4>
              <div className="space-y-3" data-id="element-1446">
                <div className="flex justify-between items-center" data-id="element-1447">
                  <div className="flex items-center" data-id="element-1448">
                    <ClockIcon className="w-4 h-4 text-muted-foreground mr-2" data-id="element-1449" />
                    <span className="text-sm text-foreground/70" data-id="element-1450">
                      Not Started
                    </span>
                  </div>
                  <span className="text-sm font-medium text-foreground" data-id="element-1451">2</span>
                </div>
                <div className="flex justify-between items-center" data-id="element-1452">
                  <div className="flex items-center" data-id="element-1453">
                    <AlertCircleIcon className="w-4 h-4 text-warning mr-2" data-id="element-1454" />
                    <span className="text-sm text-foreground/70" data-id="element-1455">
                      In Progress
                    </span>
                  </div>
                  <span className="text-sm font-medium text-foreground" data-id="element-1456">1</span>
                </div>
                <div className="flex justify-between items-center" data-id="element-1457">
                  <div className="flex items-center" data-id="element-1458">
                    <CheckCircleIcon className="w-4 h-4 text-success mr-2" data-id="element-1459" />
                    <span className="text-sm text-foreground/70" data-id="element-1460">Ready</span>
                  </div>
                  <span className="text-sm font-medium text-foreground" data-id="element-1461">1</span>
                </div>
                <div className="flex justify-between items-center" data-id="element-1462">
                  <div className="flex items-center" data-id="element-1463">
                    <FileTextIcon className="w-4 h-4 text-primary mr-2" data-id="element-1464" />
                    <span className="text-sm text-foreground/70" data-id="element-1465">
                      Submitted
                    </span>
                  </div>
                  <span className="text-sm font-medium text-foreground" data-id="element-1466">1</span>
                </div>
              </div>
            </div>
            <div className="pt-4 border-t border-border" data-id="element-1467">
              <h4 className="text-sm font-medium text-foreground/70 mb-3" data-id="element-1468">
                Filter By Pool
              </h4>
              <div className="space-y-2" data-id="element-1469">
                <label className="flex items-center" data-id="element-1470">
                  <input type="checkbox" className="h-4 w-4 text-primary border-border rounded" checked data-id="element-1471" />
                  <span className="ml-2 text-sm text-foreground/70" data-id="element-1472">
                    Q3 RTL Pool
                  </span>
                </label>
                <label className="flex items-center" data-id="element-1473">
                  <input type="checkbox" className="h-4 w-4 text-primary border-border rounded" checked data-id="element-1474" />
                  <span className="ml-2 text-sm text-foreground/70" data-id="element-1475">
                    Bridge Loan Package
                  </span>
                </label>
                <label className="flex items-center" data-id="element-1476">
                  <input type="checkbox" className="h-4 w-4 text-primary border-border rounded" data-id="element-1477" />
                  <span className="ml-2 text-sm text-foreground/70" data-id="element-1478">
                    Fixed Rate Bundle
                  </span>
                </label>
              </div>
            </div>
            <div className="pt-4 border-t border-border" data-id="element-1479">
              <h4 className="text-sm font-medium text-foreground/70 mb-3" data-id="element-1480">
                Filter By Type
              </h4>
              <div className="space-y-2" data-id="element-1481">
                <label className="flex items-center" data-id="element-1482">
                  <input type="checkbox" className="h-4 w-4 text-primary border-border rounded" checked data-id="element-1483" />
                  <span className="ml-2 text-sm text-foreground/70" data-id="element-1484">DBRS</span>
                </label>
                <label className="flex items-center" data-id="element-1485">
                  <input type="checkbox" className="h-4 w-4 text-primary border-border rounded" checked data-id="element-1486" />
                  <span className="ml-2 text-sm text-foreground/70" data-id="element-1487">Acra</span>
                </label>
                <label className="flex items-center" data-id="element-1488">
                  <input type="checkbox" className="h-4 w-4 text-primary border-border rounded" checked data-id="element-1489" />
                  <span className="ml-2 text-sm text-foreground/70" data-id="element-1490">
                    Lima One
                  </span>
                </label>
              </div>
            </div>
          </div>
        </Card>
        <Card className="col-span-3" data-id="element-1491">
          <div className="flex justify-between items-center mb-6" data-id="element-1492">
            <h3 className="text-lg font-medium text-card-foreground" data-id="element-1493">
              {activeMonth} Surveillance Items
            </h3>
            <div className="flex items-center" data-id="element-1494">
              <input type="text" placeholder="Search items..." className="border border-border rounded-md px-3 py-1.5 mr-2 bg-background" data-id="element-1495" />
              <select className="border border-border rounded-md px-3 py-1.5 bg-background" data-id="element-1496">
                <option data-id="element-1497">All Statuses</option>
                <option data-id="element-1498">Not Started</option>
                <option data-id="element-1499">In Progress</option>
                <option data-id="element-1500">Ready</option>
                <option data-id="element-1501">Submitted</option>
              </select>
            </div>
          </div>
          <div className="space-y-4" data-id="element-1502">
            {filteredItems.map(item => <div key={item.id} className="border border-border rounded-lg p-4 hover:bg-muted" data-id="element-1503">
                <div className="flex justify-between" data-id="element-1504">
                  <div className="flex items-start" data-id="element-1505">
                    <div className="mr-4" data-id="element-1506">{getStatusIcon(item.status)}</div>
                    <div data-id="element-1507">
                      <h4 className="font-medium text-foreground" data-id="element-1508">
                        {item.title}
                      </h4>
                      <div className="flex items-center mt-1" data-id="element-1509">
                        <span className="text-sm text-muted-foreground mr-3" data-id="element-1510">
                          Pool: {item.pool}
                        </span>
                        <span className="text-sm text-muted-foreground mr-3" data-id="element-1511">
                          Type: {item.type}
                        </span>
                        <span className="text-sm text-muted-foreground flex items-center" data-id="element-1512">
                          <CalendarIcon className="w-3 h-3 mr-1" data-id="element-1513" />
                          Due: {item.dueDate}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center" data-id="element-1514">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full mr-4 ${getStatusBadgeClass(item.status)}`} data-id="element-1515">
                      {item.status}
                    </span>
                    <button className="text-primary hover:text-primary/80 text-sm" data-id="element-1516">
                      {item.status === 'Not Started' && 'Start Preparation'}
                      {item.status === 'In Progress' && 'Continue Editing'}
                      {item.status === 'Ready' && 'Submit Report'}
                      {item.status === 'Submitted' && 'View Submission'}
                    </button>
                  </div>
                </div>
              </div>)}
          </div>
          <div className="mt-8 border-t border-border pt-6" data-id="element-1517">
            <h3 className="text-lg font-medium text-card-foreground mb-4" data-id="element-1518">
              Submission History
            </h3>
            <div className="overflow-x-auto" data-id="element-1519">
              <table className="min-w-full divide-y divide-border" data-id="element-1520">
                <thead className="bg-muted" data-id="element-1521">
                  <tr data-id="element-1522">
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider" data-id="element-1523">
                      Report
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider" data-id="element-1524">
                      Pool
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider" data-id="element-1525">
                      Submitted Date
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider" data-id="element-1526">
                      Submitted By
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider" data-id="element-1527">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-card divide-y divide-border" data-id="element-1528">
                  <tr className="hover:bg-muted" data-id="element-1529">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-foreground" data-id="element-1530">
                      Monthly Performance Report
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-muted-foreground" data-id="element-1531">
                      Q3 RTL Pool
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-muted-foreground" data-id="element-1532">
                      Apr 15, 2023
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-muted-foreground" data-id="element-1533">
                      Sarah Wilson
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-primary" data-id="element-1534">
                      <button className="hover:text-primary/80" data-id="element-1535">
                        Download
                      </button>
                    </td>
                  </tr>
                  <tr className="hover:bg-muted" data-id="element-1536">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-foreground" data-id="element-1537">
                      Quarterly Collateral Review
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-muted-foreground" data-id="element-1538">
                      Bridge Loan Package
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-muted-foreground" data-id="element-1539">
                      Apr 30, 2023
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-muted-foreground" data-id="element-1540">
                      Michael Brown
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-primary" data-id="element-1541">
                      <button className="hover:text-primary/80" data-id="element-1542">
                        Download
                      </button>
                    </td>
                  </tr>
                  <tr className="hover:bg-muted" data-id="element-1543">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-foreground" data-id="element-1544">
                      Delinquency Report
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-muted-foreground" data-id="element-1545">
                      Bridge Loan Package
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-muted-foreground" data-id="element-1546">
                      May 5, 2023
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-muted-foreground" data-id="element-1547">
                      Sarah Wilson
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-primary" data-id="element-1548">
                      <button className="hover:text-primary/80" data-id="element-1549">
                        Download
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Card>
      </div>
    </div>;
}